import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { LargeListCard } from 'appSrc/components/List';
import { LargeArticleCard } from 'appSrc/components/Article';
import { Icon } from 'appSrc/components/UI';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

const carouselOptions = {
    infinite: false,
    lazyLoad: 'progressive',
    swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: <Icon source='custom' icon='carousel-prev' size={ 60 } />,
    nextArrow: <Icon source='custom' icon='carousel-next' size={ 60 } />,
    responsive: [
        {
            breakpoint:840,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint:480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

class LargeCardCarousel extends PureComponent {
    render() {
        const { carousel } = this.props;
        const content = carousel.content || [];

        return (
            <div className={ `${ style.largeCardCarousel } ${ this.props.className }`.trim() }>
                { content.length > 0 &&
                    <div className={ style.carouselWrapper }>
                        { carousel.title &&
                            <div className={ style.carouselTitleBar }>
                                <h2>{ carousel.title }</h2>
                                { carousel.link_url &&
                                    <Link to={ carousel.link_url }>{ carousel.link_text || 'See All' }</Link>
                                }
                            </div>
                        }
                        <Slider { ...carouselOptions }>
                            { content.map( ( item ) => {
                                if( item.type == 'list' ) {
                                    return (
                                        <div className={ style.cardWrapper } key={ 'featured-list-carousel-' + item.listid }>
                                            <LargeListCard list={ item } />
                                        </div>
                                    );
                                } else if( item.type == 'curated_article' ) {
                                    return (
                                        <div className={ style.cardWrapper } key={ 'featured-article-carousel-' + item.listid }>
                                            <LargeArticleCard article={ item } />
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            } ) }
                        </Slider>
                    </div>
                }
            </div>
        );
    }
}
LargeCardCarousel.propTypes = {
    className: PropTypes.string,
    carousel: PropTypes.object,
};
LargeCardCarousel.defaultProps = {
    className: '',
    carousel: {},
};

export default LargeCardCarousel;
